export const AUTHORITIES = {
  API_KEY: {
    LIST: "merpmpapkli",
    CREATE: "merpmpapkcr",
    DELETE: "merpmpapkde",
    ADMIN: "merpmpapkad",
  },
  PURCHASE: {
    GET: "merpmpprchge",
    LIST: "merpmpprchli",
    ADMIN: "merpmpprchad",
  },
  USER: {
    CREATE: "merpmpusrcr",
    UPDATE_SELF: "merpmpusrups",
    UPDATE_ROLES: "merpmpusrupr",
    CHANGE_PWD: "merpmpusrpw",
    LOCK: "merpmpusrlo",
    UNLOCK: "merpmpusrul",
    RESET: "merpmpusrre",
    GET: "merpmpusrge",
    UPDATE: "merpmpusrup",
    DELETE: "merpmpusrde",
    LIST: "merpmpusrli",
    ADMIN: "merpmpusrad",
  },
  APPLICATION: {
    GET: "merpmpapplcge",
    LIST: "merpmpapplcli",
    ADMIN: "merpmpapplcad",
  },
  BNPL: {
    APPLICATION: {
      LIST: "merpmpbnpli",
      ADMIN: "merpmpbnpad",
      GET: "merpmpbnpge",
      EXPORT: "merpmpbnpex",
    },
  },
};
